import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Stack, Typography} from 'views/components';

import {Translate} from 'views/module';

import {FEEDBACK_OPTIONS} from '../../../utils/constants';
import HappinessScoreButton from './HappinessScoreButton';

const HappinessScoreCard = (props) => {
  const {
    questionTitleKey,
    happinessScore,
    setHappinessScore,
  } = props;

  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: '12px',
        p: 3,
      }}
    >
      <Typography
        sx={{
          fontSize: '1.2rem',
          fontWeight: 600,
        }}
      >
        <Translate expression={questionTitleKey}/>
      </Typography>
      <Stack
        direction="row"
        justifyContent="center"
        spacing={2}
        sx={{
          mt: 2,
        }}
      >
        {
          FEEDBACK_OPTIONS.map((option) => (
            <HappinessScoreButton
              key={option.value}
              option={option}
              happinessScore={happinessScore}
              setHappinessScore={setHappinessScore}
              buttonColor={option.color}
            />
          ))
        }
      </Stack>
    </Paper>
  );
};

HappinessScoreCard.propTypes = {
  questionTitleKey: PropTypes.string.isRequired,
  happinessScore: PropTypes.string.isRequired,
  setHappinessScore: PropTypes.func.isRequired,
};

export default React.memo(HappinessScoreCard);
